import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30f91002")

_pushScopeId("data-v-30f91002")
const _hoisted_1 = { class: "make-order-page" }
const _hoisted_2 = { class: "make-order-page-form" }
const _hoisted_3 = { class: "make-order-page-btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "预约会议",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { ref: "meetingroom" }, {
        default: _withId(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withId(() => [
              _createVNode(_component_van_field, {
                readonly: "",
                clickable: "",
                label: "会议室",
                modelValue: _ctx.meetRoom,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.meetRoom = $event)),
                placeholder: "请选择会议室",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMeetPicker = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: _ctx.showMeetPicker,
                "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showMeetPicker = $event)),
                round: "",
                position: "bottom"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_picker, {
                    "show-toolbar": "",
                    columns: _ctx.columns,
                    onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMeetPicker = false)),
                    onConfirm: _ctx.meetonConfirm
                  }, null, 8, ["columns", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                rows: "3",
                modelValue: _ctx.meetingName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.meetingName = $event)),
                type: "textarea",
                name: "公司/项目",
                label: "公司/项目",
                placeholder: "请输入公司/项目",
                rules: [{pattern:/^.{1,50}$/, required: true, message: '请输入公司/项目' }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingNum,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.meetingNum = $event)),
                type: "number",
                name: "会议人数",
                label: "会议人数",
                placeholder: "请输入会议人数",
                rules: [{pattern:/^.{1,20}$/, required: true, message: '请输入会议人数' }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.bookingPerson,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.bookingPerson = $event)),
                type: "text",
                name: "预定人",
                label: "预定人",
                placeholder: "请输入预定人",
                rules: [{pattern:/^.{1,20}$/, required: true, message: '请输入预定人' }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.tel,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.tel = $event)),
                type: "text",
                name: "联系人手机",
                label: "联系人手机",
                placeholder: "请输入联系人手机",
                rules: [{pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '请输入联系人手机' }]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingStartTimeStr,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.meetingStartTimeStr = $event)),
                "is-link": "",
                readonly: "",
                name: "datetimePicker",
                label: "开始时间",
                placeholder: "请选择开始时间",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openTime(0)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: _ctx.showPicker,
                "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (_ctx.showPicker = $event)),
                position: "bottom"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_datetime_picker, {
                    type: "datetime",
                    filter: _ctx.filter,
                    modelValue: _ctx.currentTime,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentTime = $event)),
                    onConfirm: _ctx.onConfirm,
                    onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPicker = false))
                  }, null, 8, ["filter", "modelValue", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.meetingEndTimeStr,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.meetingEndTimeStr = $event)),
                "is-link": "",
                type: "datetime",
                readonly: "",
                name: "datetimePicker",
                label: "结束时间",
                placeholder: "请选择开始时间",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openTime(1)))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "make-order-page-btn-order",
        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.confirmMeetroom && _ctx.confirmMeetroom(...args)))
      }, "预约")
    ])
  ]))
})